/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Space, Typography, Row, Col, Card, Modal } from "antd";
import classNames from 'classnames';
import { bindActionCreators } from "redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import fssaiNumberLogo from "assets/img/fssai-logo.png";
import { selectWholesaler } from "reducers/wholesalers";
import { errorToast } from "utilities/utils";
import { navigateToMyRewards } from "app/navigation";
import { clearHistoryFilter } from "reducers/orderHistory/historyFilter";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { confirm } = Modal;
const { Text } = Typography;
/* Const,Let & Var will be here */

class ApprovedWholesalerListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoader: false
    };
  }

  UNSAFE_componentWillReceiveProps() {
    if (this.state.showLoader)
      this.setState({
        showLoader: false
      });
  }

  /* Redirect to specific page when based on the requested target */
  distributorSwitchSuccessCallback = () => {
    if (this.props.redirectToCode !== "" && this.props.redirectToCode === "myRewards") {
      this.props.actions.clearHistoryFilter();
      this.props.actions.navigateToMyRewards();
    }
  };

  switchWholesaler = () => {
    const { wholesaler, translate, localStore, cart, salesReturnSummary, isFromHeader } = this.props;

    /* Switch distributor when the request come from manage distributor screen */
    if (!isFromHeader) {
      if (wholesaler.dId !== localStore.selectedWholesaler.dId) {
        /* Check for any products added into the cart */
        if (cart.ids.length === 0 && salesReturnSummary.data.length === 0) {
          confirm({
            title: translate("wholesaler.switch.switchConfirmation"),
            centered: true,
            okText: translate("common.buttons.ok"),
            cancelText: translate("common.buttons.cancel"),
            onOk: () => {
              this.props.actions.selectWholesaler(wholesaler, false, false, this.distributorSwitchSuccessCallback);
            }
          });
        }
        else {
          errorToast({ content: translate("wholesaler.switch.validationMsg") });
        }
      }
    }
  }

  render() {
    const { wholesaler, translate, localStore, isFromHeader } = this.props;

    return (
      <Card
        size="small"
        hoverable={(wholesaler.dId === localStore.selectedWholesaler.dId || isFromHeader) ? false : true}
        className={classNames('border-radius-15', 'ant-card-with-box-shadow', 'w-100', 'mb-2', {
          'selected-dist-card': wholesaler.dId === localStore.selectedWholesaler.dId
        })}
        onClick={this.switchWholesaler}
      >
        <h6>{wholesaler.dName}</h6>

        <Row>
          <Col span={20}>
            <div className="whole-seller-address">
              <p className="whole-seller__description responsive-font-size pad--l--0 mt-2">
                {wholesaler.address}
              </p>
            </div>
          </Col>
          <Col span={4} className="text-center">
            {wholesaler.dId === localStore.selectedWholesaler.dId &&
              <i className="fa fa-check-circle-o selected-dist-tick" aria-hidden="true"></i>
            }
          </Col>
        </Row>


        {/* Distributor Fssai Number section */}
        {(wholesaler.fssaiNo !== undefined && wholesaler.fssaiNo !== null) &&
          <div className="p-2">
            <Space>
              <img className="pb-1" src={fssaiNumberLogo} alt="" />
              <Text strong>{wholesaler.fssaiNo}</Text>
            </Space>
          </div>
        }

        <div className="p-1">
          <Row>
            <Col span={16}>
              {(wholesaler.contact !== null && wholesaler.contact !== "") &&
                <Space size="small" className="cursor-pointer" onClick={() => window.location.href = `tel:${wholesaler.contact}`} >
                  <i className="fa fa-phone color-primary" aria-hidden="true" />
                  <Text className="color-primary responsive-font-size">{wholesaler.contact}</Text>
                </Space>
              }
            </Col>
            <Col span={8}>
              {wholesaler.IsDefault &&
                <span onClick={e => e.preventDefault()} className="default__green--text">
                  {translate("wholesaler.default")}
                </span>
              }
            </Col>
          </Row>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = state => {
  return {
    localStore: state.localStore,
    cart: state.cart,
    salesReturnSummary: state.salesReturnSummary,
    translate: getTranslate(state.locale)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        selectWholesaler,
        navigateToMyRewards,
        clearHistoryFilter
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedWholesalerListItem);